<template>
  <div class="detail">
    <!-- 首页导航 -->
    <home-header />
    <!-- 个人中心菜单 -->
    <personal-center />
    <!-- 列表明细 -->
    <div class="content page-width" style="padding: 0px;">
      <div class="content-right pull-left" style="margin-top: 0px">
        <a-spin :spinning="detailSpinning">
          <detail-list :article="article" :reviewInfo="reviewInfo" @submitSuccess="getDetailInfo" />
        </a-spin>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import InsidePageLeft from "@/common/components/InsidePageLeft";
import Foot from "@/common/components/Foot";
import DetailList from "./components/DetailList";
import PersonalCenter from "@/common/components/PersonalCenter";
export default {
  name: "Index",
  components: {
    HomeHeader,
    Foot,
    DetailList,
    InsidePageLeft,
    PersonalCenter
  },
  data() {
    return {
      article: {},
      detailSpinning: true,
      reviewInfo: {}
    };
  },
  mounted() {
    this.getDetailInfo();
  },
  methods: {
    async getDetailInfo() {
      this.detailSpinning = true;
      try {
        const res = await this.axios.get(`/biz/home/document/detail`, {
          params: { id: this.$route.params.id }
        });
        if (res.success) {
          const res2 = await this.axios.get(
            "/biz/home/document/stuBackDocDetail",
            { params: { id: this.$route.params.id } }
          );
          if (res2.success) {
            this.reviewInfo = res2.result || {};
            res.result.visibles = JSON.parse(res.result.visibles || "[]");
            res.result.visibles.forEach(item => {
              item.value = this.reviewInfo[item.label] || undefined;
            });
            res.result.configList.forEach(item => {
              item.fileList = (this.reviewInfo.docList || []).filter(
                ite => ite.configId === item.id
              );
            });
          }
          this.article = res.result;
        }
      } finally {
        this.detailSpinning = false;
      }
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;
    width:100%;
    overflow: hidden;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}

.content {
  padding: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.detail {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/documentDetail/Index.vue